// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3VqaJ","col":"styles_col__3tXOA"};